webpackJsonp([243827335300663],{

/***/ 674:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Models = __webpack_require__(18);
	
	var _Models2 = _interopRequireDefault(_Models);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Models2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'validate'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'validate()'
	      ),
	      ' method can be used to validate whether the attributes provided to a model are valid.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This method does nothing by default, and it\'s rare that you would need it.'
	    ),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Default Implementation'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default implementation looks like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      // Run validation against the next complete set of model attributes,\n      // returning `true` if all is well. Otherwise, fire an `"invalid"` event.\n      validate: function(attrs, options) {\n        // does nothing\n      }\n      ' }),
	    _react2.default.createElement(
	      'h3',
	      null,
	      'Usage'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'Let\'s say you you\'re creating a tweet, and for some reason, a tweet is considered invalid if the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'text'
	      ),
	      ' property is equal to "Some old tweet".'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You could use the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'validate()'
	      ),
	      ' method to check for that like this:'
	    ),
	    _react2.default.createElement(_Markdown2.default, { type: 'jsx', text: '\n      import { Model } from \'lore-models\';\n\n      const Tweet = Model.extend({\n        validate: function(attributes, options) {\n          if (attributes.text === \'Some old tweet\') {\n            return \'Text is invalid\';\n          }\n        }\n      })\n\n      const t1 = new Tweet({\n        text: \'Some old tweet\'\n      })\n      const t2 = new Tweet({\n        text: \'Some new tweet\'\n      })\n      ' }),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'validate()'
	      ),
	      ' method will be executed when the tweet is created, or when attributes are updated via the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'set()'
	      ),
	      ' method.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can check if the tweet is considered valid by inspecting the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'validationError'
	      ),
	      ' property.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'In this case, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        't1.validationError'
	      ),
	      ' will return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        '\'Text is invalid\''
	      ),
	      ', because that\'s what the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'validate()'
	      ),
	      ' method returned. On the other hand, ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'tw.validationError'
	      ),
	      ' will return ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'null'
	      ),
	      ', because there was no validation error.'
	    )
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-models-properties-validate-js-83f6722b80f1a05deb7e.js